import { render } from "./TownList.vue?vue&type=template&id=3bbc809a&scoped=true"
import script from "./TownList.vue?vue&type=script&lang=js"
export * from "./TownList.vue?vue&type=script&lang=js"

import "./TownList.vue?vue&type=style&index=0&id=3bbc809a&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbc809a"]])

export default __exports__